/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaVisibility/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaVisibility({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaVisibility",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaVisibility.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-ZD5UVH': alignSelf,'--mt-2-ZD5UVH': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZD5UVH': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZD5UVH': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZD5UVH': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZD5UVH': opacity,'--w-10-ZD5UVH': typeof width === 'number' ? `${width}px` : width,'--h-11-ZD5UVH': typeof height === 'number' ? `${height}px` : height,'--f-12-ZD5UVH': fill,'--a-7-ZD5UVH': isAnimated ? animation : "none",'--sd-8-ZD5UVH': isAnimated ? strokeDashoffset : 0,'--sd-9-ZD5UVH': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaVisibility.SvgPath"
  data-view-path={viewPath}
 d="M12 15.75c1.183 0 2.188-.412 3.012-1.238.825-.825 1.238-1.829 1.238-3.012s-.412-2.188-1.238-3.012C14.188 7.663 13.183 7.25 12 7.25s-2.188.412-3.012 1.238c-.825.825-1.238 1.829-1.238 3.012s.412 2.188 1.238 3.012c.825.825 1.829 1.238 3.012 1.238zm0-1.45c-.783 0-1.446-.27-1.988-.813-.541-.541-.812-1.204-.812-1.987 0-.783.27-1.446.813-1.988.541-.541 1.204-.812 1.987-.812.783 0 1.446.27 1.988.813.541.541.812 1.204.812 1.987 0 .783-.27 1.446-.813 1.988-.541.541-1.204.812-1.987.812zm0 4.7c-2.433 0-4.633-.692-6.6-2.075C3.433 15.542 1.967 13.733 1 11.5c.967-2.233 2.433-4.042 4.4-5.425C7.367 4.692 9.567 4 12 4s4.633.692 6.6 2.075c1.967 1.383 3.433 3.192 4.4 5.425-.967 2.233-2.433 4.042-4.4 5.425C16.633 18.308 14.433 19 12 19zm0-1.5c2.017 0 3.87-.546 5.563-1.637a10.626 10.626 0 003.862-4.363 10.626 10.626 0 00-3.863-4.362A10.053 10.053 0 0012 5.5c-2.017 0-3.87.546-5.563 1.638A10.804 10.804 0 002.55 11.5c.9 1.817 2.196 3.27 3.888 4.363A10.053 10.053 0 0012 17.5z"
 style={{'--f-12-ZD5UVH': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}